import React from 'react';
import { ContainerRail, IconContainer, IconsRow, LogoShowcaseAutoScrollContainer } from './LogoShowcaseRail.styles';

interface LogoShowcaseRailProps {
  logos: ((props: any) => JSX.Element)[];
  fadeElementColor?: string;
}

const LogoShowcaseRail = ({ logos, fadeElementColor }: LogoShowcaseRailProps): JSX.Element => {
  // Necessary for the auto-scrolling effect
  const duplicatedRow = [...logos, ...logos];

  return (
    <LogoShowcaseAutoScrollContainer
      className='logo-showcase-auto-scroll-container'
      fadeElementColor={fadeElementColor}
    >
      <ContainerRail>
        <IconsRow>
          {duplicatedRow.map((Logo, index) => (
            <IconContainer key={index}>
              <Logo />
            </IconContainer>
          ))}
        </IconsRow>
      </ContainerRail>
    </LogoShowcaseAutoScrollContainer>
  );
};

export default LogoShowcaseRail;
